var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCowry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_534_4044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25586 24.1072C7.44136 24.2392 8.61649 23.7885 9.41005 22.8975",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41406 22.8975C10.4026 23.8521 11.9682 23.8521 12.9567 22.8975",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9512 22.8975C13.2615 23.5078 13.8871 23.8915 14.5715 23.8915C15.2558 23.8915 15.8814 23.5078 16.1918 22.8975",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1973 22.8975C16.5498 23.5445 17.1726 23.9993 17.8957 24.1369C18.618 24.2758 19.3653 24.083 19.9314 23.6129",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9258 23.6133C20.2541 24.3439 20.915 24.87 21.6988 25.0283C22.4827 25.1866 23.2963 24.9557 23.8811 24.4096",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8789 24.4102C24.2999 25.0026 24.9628 25.3793 25.6879 25.4374C26.413 25.4954 27.1264 25.2307 27.6373 24.7122",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6426 24.7119C28.0801 25.2075 28.7092 25.491 29.3707 25.491C30.0322 25.491 30.6613 25.2075 31.0988 24.7119",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0957 24.7119C32.0607 25.5705 33.4881 25.6596 34.552 24.9269",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5586 24.9268C35.0881 25.4265 35.8187 25.6533 36.5377 25.5385C37.2566 25.4252 37.8815 24.9834 38.2305 24.3447",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2266 24.3454C39.5399 24.745 40.9432 24.0807 41.4672 22.8115",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25586 24.1074C6.56347 24.6272 6.56347 25.2729 6.25586 25.7927",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25586 25.792C7.3432 25.792 8.32686 26.4376 8.76166 27.4337",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76367 27.4344C9.80055 26.8171 11.125 26.9968 11.9607 27.8664",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.957 27.8663C12.4451 27.5947 13.025 27.5408 13.5545 27.7177C14.0854 27.8947 14.5161 28.2859 14.7442 28.7954",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.748 28.7942C15.7988 27.9384 17.305 27.9384 18.3557 28.7942",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3555 28.7949C18.8297 28.3518 19.4843 28.1589 20.1216 28.2737C20.7603 28.3884 21.3064 28.799 21.5961 29.3783",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5957 29.3781C22.0022 28.9067 22.5932 28.6357 23.216 28.6357C23.8388 28.6357 24.4298 28.9074 24.8363 29.3781",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.834 29.3776C25.2757 28.8267 25.9566 28.5246 26.6617 28.5675C27.3667 28.6104 28.0055 28.9926 28.3767 29.5933",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3789 29.5946C29.4303 28.6214 31.025 28.5308 32.1808 29.3783",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1895 29.3776C32.5593 28.8156 33.1607 28.4472 33.8298 28.376C34.4989 28.3048 35.1653 28.535 35.6457 29.0064",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6387 29.0073C35.9007 28.3886 36.4136 27.9096 37.0495 27.6925C37.6855 27.4754 38.385 27.5384 38.9705 27.8667",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9675 27.8661C39.0974 27.3435 39.4479 26.9046 39.929 26.6633C40.4094 26.4228 40.8262 26.2672 41.7263 26.2672C41.7263 26.2672 42.8502 26.5562 42.8502 27.6497C42.8502 30.4147 35.6349 37.3273 24.1864 37.3273C10.0737 37.3273 1.375 27.2474 1.375 24.1935C1.375 21.1409 4.27827 19.7425 6.90503 17.339C8.66427 15.7297 12.377 6.91211 25.5689 6.91211C35.2464 6.91211 38.5375 15.7823 39.394 16.5897C40.2504 17.3984 42.8502 19.8731 42.8502 21.4284C42.8502 22.9851 41.4677 22.811 41.4677 22.811",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6854 26.9954C42.8499 25.5686 42.807 23.2246 42.375 22.5762",
    stroke: "#84C70D",
    strokeWidth: 2.76502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_534_4044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.2403,
    height: 44.2403,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCowry);
export default __webpack_public_path__ + "static/media/cowry.5a3a1bdc18e4d4d0b6585caa0b7058b2.svg";
export { ForwardRef as ReactComponent };